<template>
    <div ref="container">
      <v-text-field
        v-if="inputType!=='textArea'"
        :name="name"
        :key="keyValue"
        class="flex ma-0"
        outlined
        :color="compColor.textInput"
        :dark="compColor.isInDarkMode"
        :background-color="backgroundColor"
        :label="label"
        :placeholder="placeholder"
        :hint="hint"
        :persistent-hint="persistent_hint"
        :suffix="suffix"
        ref="input"
        v-model="internalModel"
        @blur="updateValue"
        :required="required"
        :hide-details="hideDetails"
        :disabled="disabled"
        :dense="dense"
        :error-messages="getErrorMsg">
      </v-text-field>

      <v-textarea
        v-if="inputType==='textArea'"
        auto-grow
        :rows="rows"
        class="flex ma-0"
        :name="name"
        :key="keyValue"
        outlined
        :color="compColor.primeColor"
        :dark="compColor.isInDarkMode"
        :background-color="backgroundColor"
        :label="label"
        :placeholder="placeholder"
        :hint="hint"
        :persistent-hint="persistent_hint"
        ref="textarea"
        v-model="internalModel"
        @blur="updateValue"
        :dense="dense"
        :hide-details="hideDetails"
        :disabled="disabled"
        :error-messages="getErrorMsg"
      ></v-textarea>
    </div>
</template>

<script>
import Vue from 'vue'

export default Vue.component('longInput', {
  /**
   * ##########################################################################################################
   * #  notwendig damit Kommunikation mit der Validierung vee-validate in der Parent Komponente funktioniert  #
   * ##########################################################################################################
   * */
  $_veeValidate: {
    name () {
      return this.name
    },
    value () {
      return this.value
    }
  },
  data () {
    return {
      internalModel: '', // enthält das v-model des inputfeldes innerhalb des LongInput
      internalChange: false, // ob das Parent v-model aus dem LongInput heraus geändert wurde 'true' oder von außen 'false'
    }
  },
  props: {
    value:{
      type: String
    },
    inputType:{
      type: String
    },
    name: {
      type: String
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    suffix: {
      type: String
    },
    backgroundColor: {
      type: String
    },
    hideDetails: {
      type: [Boolean, String],
      default: false
    },
    rows: {
      type: String,
      default: '1'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: { // bekommt die Errormessages übergeben
      type: [Array, String],
      required: false
    },
    required: {
      type: [Boolean]
    },
    dense: {
      type: [Boolean]
    },
    hint: {
      type: String
    },
    persistent_hint: {
      type: Boolean
    },
    keyValue: {
      type: String
    }
  },
  computed: {
    /**
     * wenn vee-validate in der Parentkomponente einen Fehler erkennt und damit this.error sich ändert dann werden
     * hier im Datepicker die Errormessages getriggert durch diese computed Property
     * */
    getErrorMsg: function () {
      if (!this.error) {
        return []
      }
      return this.error
    },
  },
  methods: {
    /**
     * wird aufgerufen wenn man das Input Feld verlässt, da dabei der onBlur Event geworfen wird
     * der eingegebene String wird dabei an das v-model der parent Komponente übergeben mittels $emit('input' ...)
     * nur so ist eine reactive Änderung möglich und das Partent Model bekommt die Änderung aktiv mit
     * */
    updateValue (e) {
      let payload = e.target.value
      this.internalValue = payload
      this.$emit('input', payload)
    }
  },
  watch: {
    /**
     * Lauscht auf dem v-model des parents dieser Komponente, wenn also von außen über GetData oder ein Reset
     * der Wert geändert wird
     *
     * */
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === undefined && this.internalChange) {
            this.internalChange = false
            this.internalModel = ''
          } else {
            this.internalModel = newValue
            this.internalValue = newValue
          }
        }
      },
      immediate: true
    }
  }
})
</script>
